export default __webpack_public_path__ + "static/media/label.034453d3.svg";